import { useLayoutEffect, useRef, memo } from "react";
import { useEsri } from "../EsriContext";
import { loadModules } from "esri-loader";

const GBMapSearch = memo(({ onSearchComplete, sourcesProps, popupEnabled }) => {
  const { esriLoader } = useEsri();
  const searchRef = useRef();

  useLayoutEffect(() => {
    if (!esriLoader) return;
    const modulesToLoad = ["esri/widgets/Search", "esri/tasks/Locator"];
    loadModules(modulesToLoad).then(([Search, Locator]) => {
      const defaultSoutceProps = [
        {
          locator: new Locator({
            url: "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
          }),
          countryCode: "GB",
          placeholder: "Enter postcode or place",
          maxResults: 3,
          maxSuggestions: 6,
          suggestionsEnabled: true,
          minSuggestCharacters: 0,
          ...sourcesProps,
        },
      ];
      const searchWidget = new Search({
        view: esriLoader.view,
        container: searchRef.current,
        sources: defaultSoutceProps,
        includeDefaultSources: true,
        autoSelect: true,
        popupEnabled: popupEnabled ?? popupEnabled,
      });

      if (onSearchComplete) {
        searchWidget.on("search-complete", function (event) {
          const geometryPoint = event["results"][0]["results"][0]["feature"];
          onSearchComplete(event, geometryPoint, searchWidget);
        });
      }
    });

    return () => {};
  }, [esriLoader, onSearchComplete, popupEnabled, sourcesProps]);

  return (
    <div className="esri-map-search">
      <div ref={searchRef}></div>
    </div>
  );
});

export default GBMapSearch;
